import axios from "axios";
import React, { useState, useEffect, useMemo } from "react";
import Collapse from "react-bootstrap/Collapse";
import { get_sessions, get_rooms_url, getCustomers, viewReport } from "./apis";
import { Search } from "./../Components/DataTable";
import { Pagination } from "./../Components/DataTable";
import "./../Assets/css/utility.css";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { ViewReport } from "../Components/ViewModals/CheckOutModel";
import { Header } from "../Layouts/Header";
import Select from "react-select";
import { formatDateTime } from "../Utils/dateFormat";

const ITEMS_PER_PAGE = 10;
let SessionCopy = [];
let roomsOptions = [];
let customerNameOptions = [];
let customerPhoneOptions = [];

const Report = () => {
  const [open, setOpen] = useState(false);
  const [allSessions, setAllSessions] = useState([]);
  const [allRooms, setAllRooms] = useState([]);
  const [allCustomer, setAllCustomer] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [searchSession, setSearchSession] = useState("");
  const [reportData, setReportData] = useState([]);
  const [ReportModal, setReportModal] = useState(false);
  const [filterDateField, setFilterDateField] = useState({
    sessionFrom: "",
    sessionTo: "",
  });
  const [selectedRoom, setSelectedRoom] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedPhone, setSelectedPhone] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [customerDetail, setCustomerDetail] = useState({
    name: "",
    phone: "",
  });

  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };

  useEffect(() => {
    getSessions();
    getrooms();
    get_customer();
  }, []);

  const get_all_sessions = useMemo(() => {
    let get_sessions = allSessions;

    if (searchSession) {
      get_sessions = get_sessions.filter(
        (session) =>
          session.id.toString().includes(String(searchSession).toLowerCase()) ||
          String(session?.room?.name)
            .toLowerCase()
            .includes(String(searchSession).toLowerCase()) ||
          String(session?.customer?.name)
            .toLowerCase()
            .includes(String(searchSession).toLowerCase()) ||
          String(session?.customer?.phone_number)
            .toLowerCase()
            .includes(String(searchSession).toLowerCase()) ||
          String(session?.check_in)
            .toLowerCase()
            .includes(String(searchSession).toLowerCase()) ||
          String(session?.check_out)
            .toLowerCase()
            .includes(String(searchSession).toLowerCase())
      );
    }

    setTotalItems(get_sessions.length);
    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      get_sessions = get_sessions.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return get_sessions.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [allSessions, currentPage, sorting, searchSession]);

  const getSessions = () => {
    axios
      .get(get_sessions, { headers: headers })
      .then((res) => {
        if (res.data.status === 200) {
          setAllSessions(res.data.sessions);
          SessionCopy = res.data.sessions;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getrooms = () => {
    axios
      .get(get_rooms_url, { headers: headers })
      .then((res) => {
        if (res.data.status === 200) {
          setAllRooms(res.data.rooms);
          let data = res.data.rooms;
          roomsOptions = data?.map((room) => {
            room = { value: room?.name, label: room?.name };
            return room;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const get_customer = () => {
    axios
      .get(getCustomers, { headers: headers })
      .then((res) => {
        if (res.data.status === 200) {
          setAllCustomer(res.data.customers);
          let data = res.data.customers;
          customerNameOptions = data?.map((customer) => {
            customer = { value: customer?.id, label: customer?.name };
            return customer;
          });
          customerPhoneOptions = data?.map((phone) => {
            phone = { value: phone?.id, label: phone?.phone_number };
            return phone;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleViewReport = (id) => {
    setReportModal(true);
    axios
      .get(viewReport + "/" + id, { headers: headers })
      .then((res) => {
        if (res.data.status === 200) {
          setReportData(res?.data?.report);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterDateField({
      ...filterDateField,
      [name]: value,
    });
  };

  const resetFilter = () => {
    setSelectedRoom("");
    setSelectedPhone("");
    setSelectedCustomer("");
    setFilterDateField({
      sessionFrom: "",
      sessionTo: "",
    });
    setAllSessions(SessionCopy);
  };
  const handleFilter = () => {
    let deepCopy = JSON.parse(JSON.stringify(SessionCopy));

    let filterField = {
      roomName: selectedRoom?.label,
      customerName: selectedCustomer?.label,
      customerNumber: selectedPhone?.label,
      sessionFrom: filterDateField.sessionFrom,
      sessionTo: filterDateField.sessionTo,
    };
    console.log(filterField, "filterFrield");
    // return false;
    console.log(deepCopy, "deep");
    deepCopy = deepCopy.filter((session) => {
      if (
        session?.room?.name === filterField.roomName ||
        filterField.roomName === undefined
      ) {
        if (
          session?.customer?.name === filterField.customerName ||
          filterField.customerName === undefined
        ) {
          if (
            session?.customer?.phone_number === filterField.customerNumber ||
            filterField.customerNumber === undefined
          ) {
            if (
              moment(filterField?.sessionFrom).format("MM/DD/yyyy") <=
                moment(session?.check_out).format("MM/DD/yyyy") ||
              filterField?.sessionFrom == ""
            ) {
              if (
                moment(filterDateField?.sessionTo).format("MM/DD/yyyy") >=
                  moment(session?.check_out).format("MM/DD/yyyy") ||
                filterDateField?.sessionTo == ""
              ) {
                return session;
              }
            }
          }
        }
      }
    });
    setAllSessions(deepCopy);
  };

  const CancelModal = () => {
    setReportModal(false);
  };
  const NameItem = (item) => {
    setSelectedCustomer(item);
    allCustomer.map((customer) => {
      if (customer.id == item.value) {
        setCustomerDetail({
          ...customerDetail,
          phone: customer.phone_number,
        });
      }
    });
  };
  const handlephoneNumber = () => {
    if (selectedPhone) {
      return (
        <input className="form-control" value={customerDetail?.name} disabled />
      );
    } else {
      return (
        <Select
          isClearable={true}
          name="customerName"
          onChange={(item) => NameItem(item)}
          value={selectedCustomer}
          className="input-design"
          options={customerNameOptions}
        />
      );
    }
  };
  const NumberItem = (item) => {
    setSelectedPhone(item);
    allCustomer.map((customer) => {
      if (customer.id == item.value) {
        setCustomerDetail({
          ...customerDetail,
          name: customer.name,
        });
      }
    });
  };
  const handleCustomerName = () => {
    if (selectedCustomer) {
      return (
        <input
          className="form-control"
          value={customerDetail?.phone}
          disabled
        />
      );
    } else {
      return (
        <Select
          isClearable={true}
          name="customerNumber"
          onChange={(item) => NumberItem(item)}
          value={selectedPhone}
          className="input-design"
          options={customerPhoneOptions}
        />
      );
    }
  };

  return (
    <>
      <Header userName={user?.name} />
      <h4 className="head_set">Report</h4>
      <div
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        className="bg-primary p-3 cursor-pointer text-white"
        role="button"
      >
        <p>Filter</p>
      </div>
      <Collapse in={open}>
        <div id="example-collapse-text">
          <br />
          <div className="row m-0">
            <div className="col-4">
              <label>Room</label>
              <br />

              <Select
                name="roomName"
                isClearable={true}
                onChange={setSelectedRoom}
                value={selectedRoom}
                className="input-design"
                //   {/* <option>Select...</option>
                //   {allRooms.map((room) => (
                //     <option>{room.name}</option>
                //   ))}
                //  */}
                options={roomsOptions}
                // disabled={isDisabled}
              />
            </div>
            <div className="col-4">
              <label>Customer</label>
              <br />

              {handlephoneNumber()}
            </div>
            <div className="col-4">
              <label>Mobile No</label>
              <br />
              {handleCustomerName()}
            </div>
          </div>
          <br />
          <div className="row m-0">
            <div className="col-4">
              <label>Check Out From</label>
              <input
                name="sessionFrom"
                onChange={handleChange}
                value={filterDateField.sessionFrom}
                type="date"
                placeholder=""
                className="form-control"
              />
            </div>
            <div className="col-4">
              <label>Check Out To</label>
              <input
                name="sessionTo"
                onChange={handleChange}
                value={filterDateField.sessionTo}
                type="date"
                placeholder=""
                className="form-control"
              />
            </div>
          </div>

          <div className="d-flex justify-content-start mt-3 ml-3 ">
            <button onClick={handleFilter} className="btn btn-sm btn-primary">
              Submit
            </button>
            <button
              onClick={resetFilter}
              className="btn btn-sm btn-danger ml-2"
            >
              Reset
            </button>
          </div>
        </div>
      </Collapse>

      <div className="row m-3">
        <div className="col-md-9">
          <Pagination
            total={totalItems}
            itemsPerPage={ITEMS_PER_PAGE}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
        <div className="col-md-3 d-flex flex-row-reverse">
          <Search
            onSearch={(value) => {
              setSearchSession(value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>
      <table className="table table-hover table-bordered  mt-4">
        <thead className="headDesigne">
          <tr>
            <th>Session No</th>
            <th>Room</th>
            <th>Customer Name</th>
            <th>Mobile No</th>
            <th>Check In</th>
            <th>Check Out</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {get_all_sessions.map((session) => (
            <tr key={session.id}>
              <td>{session.id}</td>
              <td>{session?.room?.name}</td>
              <td>{session?.customer?.name}</td>
              <td>{session?.customer?.phone_number}</td>
              <td>{formatDateTime(session?.check_in)}</td>
              <td>{formatDateTime(session?.check_out)}</td>
              <td>
                <p
                  className="text-primary cursor-pointer"
                  onClick={() => handleViewReport(session.id)}
                >
                  View Report
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Modal show={ReportModal} onHide={CancelModal}>
        <Modal.Header>
          <Modal.Title>View Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ViewReport reportData={reportData} />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={CancelModal}>
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Report;
